module.exports = __webpack_public_path__ + "img/11.1633f48c.png";